<div class="chunky-two-select-container">

  @if (header) {
    <div class="header">{{ header }}</div>
  }
  <div class="description">{{ description }}</div>

  <div class="buttons">
    <app-shared-button size="large" class="chunky-two-select-button" (click)="selected(option1.key)">
      {{ option1.value }}
    </app-shared-button>
    <app-shared-button size="large" class="chunky-two-select-button" (click)="selected(option2.key)">
      {{ option2.value }}
    </app-shared-button>
  </div>

</div>
